import { render, staticRenderFns } from "./MessagePanes.vue?vue&type=template&id=66744d92&"
import script from "./MessagePanes.vue?vue&type=script&lang=ts&"
export * from "./MessagePanes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports